import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "drawer-stub"
}
const _hoisted_2 = { class: "drawer-stub__content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "По этой команде ещё не было отчетов по ограничениям", -1)
const _hoisted_5 = {
  key: 1,
  class: "limit-reports-table"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "pl-2" }, "Ключевое ограничение", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "pl-2" }, "Комментарий к ограничению", -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "commentForLimit" }
const _hoisted_11 = {
  key: 0,
  class: "more-button"
}
const _hoisted_12 = {
  key: 0,
  class: "limit-reports-table__tag-row"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "pl-2" }

import { useProgramsStore } from '@/stores/programs';
import { computed } from 'vue';
import { useAccountStore } from '@/stores/account';
import { useDialogStore } from '@/stores/dialogs';
import dayjs from 'dayjs';
import stubSvg from '@/assets/stub.svg'
import VLimitTag from './VLimitTag.vue';
import CreateLimitsReportDialog from './dialogs/CreateLimitsReportDialog.vue';
import { useUiStore } from '@/stores/ui';
  

export default /*#__PURE__*/_defineComponent({
  __name: 'TeamLimitsTable',
  props: {
    team: null
  },
  setup(__props: any) {

const props = __props as { team: any }


const programsStore = useProgramsStore()
const uiStore = useUiStore()

const rows = computed(() => {
  const arr = []
  for (let i = 0; i < programsStore.limitsMeta?.length; i++) {
    const item = programsStore.limitsMeta[i]
    const lastItem = programsStore.limitsMeta[i-1]
    if (!lastItem || item.category !== lastItem.category) {
      arr.push({ type: "category", title: item.category })
    }
    arr.push(item)
  }
  return arr
})

function onLimitReportClick(report: any) {
  uiStore.infoDrawer = { open: true, title: "Комментарий к ограничению", content: report.fields["Комментарий к ограничению"] }
}

const dialogStore = useDialogStore()
const accountStore = useAccountStore()
const editReport = (report: any) => {
  console.log(report)
  dialogStore.open(CreateLimitsReportDialog, { report })
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (props.team.limits?.length === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(stubSvg),
            alt: "stub-content"
          }, null, 8, _hoisted_3),
          _hoisted_4
        ])
      ]))
    : (props.team.limits)
      ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.team.limits, (limitReport, index) => {
              return (_openBlock(), _createElementBlock("th", null, [
                _createTextVNode(_toDisplayString(_unref(dayjs)(limitReport.date).format("MMMM")) + " ", 1),
                (limitReport.trackerId === _unref(accountStore).currentUser?.id)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "edit-button",
                      icon: "mdi-pencil",
                      size: "x-small",
                      variant: "flat",
                      onClick: ($event: any) => (editReport(limitReport))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.team.limits, (limitReport) => {
                return (_openBlock(), _createElementBlock("td", null, [
                  _createElementVNode("div", null, [
                    _createVNode(VLimitTag, {
                      title: limitReport.keyLimit
                    }, null, 8, ["title"])
                  ])
                ]))
              }), 256))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_8,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.team.limits, (limitReport) => {
                return (_openBlock(), _createElementBlock("td", {
                  class: "clickable",
                  onClick: ($event: any) => (onLimitReportClick(limitReport))
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(limitReport.fields["Комментарий к ограничению"]), 1),
                  (limitReport.fields['Комментарий к ограничению']?.length > 30)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_11, "Ещё"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_9))
              }), 256))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), (field, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                ('type' in field && field.type === 'category')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, [
                          _createVNode(VLimitTag, {
                            title: field.title
                          }, null, 8, ["title"])
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.team.limits, (limitReport) => {
                        return (_openBlock(), _createElementBlock("td", null, _hoisted_14))
                      }), 256))
                    ]))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(field.title), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.team.limits, (limitReport) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: _normalizeClass({ red: limitReport.fields[field.title] < 3 })
                        }, [
                          _createElementVNode("div", null, _toDisplayString(limitReport.fields[field.title]), 1)
                        ], 2))
                      }), 256))
                    ]))
              ], 64))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})